// The BcfRouterContainer class is a container for the routers.
// It is used by the BcfActivatedRoute to get the params of the active route.
// It is also used by the BcfRouterElement to register itself.
import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { Subject } from 'rxjs';
import type { Params } from './types';

type RouteData = Record<string, any>;

export type BcfRoutesMemory = {
  routerRef: unknown;
  params: Params;
  data: RouteData | undefined;
};

export class BcfRouterContainer {
  private _memory: BcfRoutesMemory[] = [];

  public didChanged$: Subject<void> = new Subject<void>();

  // The addOrUpdateRouter method adds or updates a router in the container.
  public addOrUpdateRouter(routerRef: unknown, params: Params, data: RouteData | undefined): void {
    const isExistIndex: number = this._memory.findIndex((memory: BcfRoutesMemory) => memory.routerRef === routerRef);
    if (isExistIndex === -1) {
      this._memory.push({
        routerRef: routerRef,
        params: params,
        data: data
      });
      this.didChanged$.next(undefined);
      return;
    }
    if (isExistIndex !== -1) {
      this._memory[isExistIndex] = {
        routerRef: routerRef,
        params: params,
        data: data
      };
      this.didChanged$.next(undefined);
      return;
    }
  }

  // The removeRouter method removes a router from the container.
  public removeRouter(routerRef: unknown): void {
    const isExistIndex: number = this._memory.findIndex((memory: BcfRoutesMemory) => memory.routerRef === routerRef);
    if (isExistIndex !== -1) {
      this._memory.splice(isExistIndex, 1);
    }
  }

  // The getMemory method returns the memory of the container.
  public getMemory(): BcfRoutesMemory[] {
    return this._memory.slice();
  }
}
export function provideBcfRouterContainer(): BcfRouterContainer {
  return provideSingleton(BcfRouterContainer, () => new BcfRouterContainer());
}
